import React from 'react';
import { WebSocketManagementProps } from '../types';

const WebSocketManagement: React.FC<WebSocketManagementProps> = ({ 
  connections, 
  loading, 
  onRefresh 
}) => {
  return (
    <div className="websocket-section">
      <h3>📊 WebSocket Management</h3>
      
      <button 
        className="btn" 
        onClick={onRefresh} 
        disabled={loading}
      >
        {loading ? 'Loading...' : '🔄 Refresh Connections'}
      </button>

      {connections.length > 0 && (
        <div className="connections-list">
          <h4>Active Connections ({connections.length}):</h4>
          {connections.map((conn) => (
            <div key={conn.connectionId} className="connection-item">
              <div><strong>User:</strong> {conn.userName}</div>
              <div><strong>ID:</strong> {conn.connectionId.substring(0, 8)}...</div>
              <div><strong>Connected:</strong> {new Date(conn.connectedAt).toLocaleString()}</div>
              <div><strong>State:</strong> {conn.state}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WebSocketManagement;
